// Registry of all reports. Adding a new report = import + push here.
import { newCustomersReport } from "./reports/newCustomers";
import { deliveriesBySegmentReport } from "./reports/deliveriesBySegment";
import { revenueBySegmentReport } from "./reports/revenueBySegment";
import { utilizationBySegmentReport } from "./reports/utilizationBySegment";
import { invoicingBySegmentReport } from "./reports/invoicingBySegment";
import { invoicingByClientReport } from "./reports/invoicingByClient";
import { publicoGeneralInvoicingReport } from "./reports/publicoGeneralInvoicing";
import { utilizationPerCarReport } from "./reports/utilizationPerCar";
import { unitsInServiceReport } from "./reports/unitsInService";
import { serviceCostPerCarReport } from "./reports/serviceCostPerCar";
import { trasladoExpensesReport } from "./reports/trasladoExpenses";
import { saldoAHoyReport } from "./reports/saldoAHoy";
import { cuentasIncobrablesReport } from "./reports/cuentasIncobrables";
import { oilChangeBonusReport } from "./reports/oilChangeBonus";
import { washPayReport } from "./reports/washPay";

export const REPORTS = [
  saldoAHoyReport,
  cuentasIncobrablesReport,
  newCustomersReport,
  deliveriesBySegmentReport,
  revenueBySegmentReport,
  utilizationBySegmentReport,
  invoicingBySegmentReport,
  invoicingByClientReport,
  publicoGeneralInvoicingReport,
  utilizationPerCarReport,
  unitsInServiceReport,
  serviceCostPerCarReport,
  trasladoExpensesReport,
  oilChangeBonusReport,
  washPayReport,
];

export const getReport = (id) => REPORTS.find((r) => r.id === id) || null;

// Stable category order for the index page.
export const CATEGORY_ORDER = [
  "Finanzas",
  "Flota",
  "Clientes",
  "Operaciones",
];
